import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Base, Svg, Text } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Suggestion-root_1Ocxt",
  "iconWrapper": "Suggestion-iconWrapper_pSowH",
  "icon": "Suggestion-icon_2uY5l",
  "baseLine": "Suggestion-baseLine_PYaTw"
};
export default function Suggestion({
  id,
  title,
  price,
  description,
  children,
  onClick
}) {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsxs(Base, {
    className: styles.root,
    padding: "xsmall",
    tagName: "button",
    flex: true,
    flexJustifyBetween: true,
    flexCol: true,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(Base, {
      tagName: "span",
      className: styles.iconWrapper,
      children: /*#__PURE__*/_jsx(Svg, {
        name: "plus",
        id: `svg-icon-${id}`,
        className: styles.icon,
        title: __('Add to cart')
      })
    }), /*#__PURE__*/_jsxs(Base, {
      className: styles.baseLine,
      tagName: "strong",
      flex: true,
      flexJustifyBetween: true,
      flexAlignItemsBaseline: true,
      children: [/*#__PURE__*/_jsx(Text, {
        children: title
      }), /*#__PURE__*/_jsx(Base, {
        tagName: "span",
        size: "small",
        marginLeft: "xsmall",
        children: price
      })]
    }), description && /*#__PURE__*/_jsx(Base, {
      tagName: "span",
      size: "small",
      children: description
    }), !!children && /*#__PURE__*/_jsx(Base, {
      tagName: "span",
      size: "small",
      marginTop: "xsmall",
      children: children
    })]
  });
}